
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 5c0-.552-.45-1.006-.998-.945a9 9 0 109.943 9.943c.06-.549-.393-.998-.945-.998h-3.992c-.552 0-.985.46-1.165.982a3.007 3.007 0 11-3.825-3.825c.522-.18.982-.613.982-1.165V5z"}}),_c('path',{attrs:{"d":"M21 11c.552 0 1.006-.45.945-.998a8.997 8.997 0 00-7.947-7.947C13.449 1.995 13 2.448 13 3v3.992c0 .552.46.985.982 1.165a3.019 3.019 0 011.145.716 3.007 3.007 0 01.716 1.145c.18.522.613.982 1.165.982H21z"}})])
          )
        }
      }
    